module.exports = __webpack_public_path__ + "img/user-pilot-tie.d7937b42.svg";